import ClassificationSelector from './ClassificationSelector.jsx';

export default ClassificationSelector;


// WEBPACK FOOTER //
// ./src/components/ClassificationSelector/index.jsx